import React from "react"
import Slider from "react-slick"

import VideoWrapper from "@/components/VideoWrapper/VideoWrapper"
import { getSlickSettings } from "@/components/ImageGallery/v3/utlis"
import Image from "@/components/Shared/Image"
import zoomClose from "@/styles/images/zoom-close-icon.svg"
import threeSixtyIcon from "@/styles/images/360-spin-overlay.svg"

const ImageHeroSection = props => {
  const {
    data = [],
    pdpCustomImagesArray = [],
    zoomVideoId = "",
    closeZoomImageClick = "",
    iframeContainer = null,
    closeZoomImageModel = "",
    currentVideoId = "",
    zoomEntryPoint = "",
    getVideoInfo = () => {},
    width = 0,
    activeImage = "",
    slickRef = null,
    threeSixtyZoomClick = false,
    threeSixtyOpen = () => {},
    assetAccountName = "",
    appendPresetToUrl = () => {},
    swatchUrl = "",
    presetConfigObject = {},
    imageZoomClick = () => {},
    zoomVideoIcon = {},
    initialImgUrl = "",
    pdpDesktopImage = "",
    imageZoomVideoClick = () => {},
    initialImgAlt = "",
  } = props

  const pdpImageArrayLength = pdpCustomImagesArray?.length

  return (
    <>
      <div
        className={`image-overlay ${zoomVideoId ? "video-open" : ""}`}
        id="imageoverlay"
        tabIndex={90}
        role="dialog"
        aria-labelledby="gallery-pdp"
      >
        <span
          className="close-zoom-image"
          onClick={closeZoomImageClick}
          tabIndex={91}
          role="dialog"
          aria-labelledby="close"
          aria-label={closeZoomImageModel}
        >
          <img src={zoomClose?.src} role="button" alt="close" tabIndex={152} />
        </span>
        <div className="popup-content" tabIndex={93}>
          <div className="iframe-container" ref={iframeContainer}>
            <div id="s7viewer" tabIndex={99}></div>
            <div id="s7viewerSpinThreeSixty" tabIndex={99}></div>
            {zoomVideoId ? (
              <div className="zoom-video" id="zoomVideo">
                <VideoWrapper
                  videoId={zoomVideoId}
                  width="100%"
                  playVideoClick={true}
                  index={currentVideoId}
                  totalPdpImages={pdpImageArrayLength}
                  zoomEntryPoint={zoomEntryPoint}
                  getVideoInfo={getVideoInfo}
                />
              </div>
            ) : null}
            <div
              className="gallery"
              id="gallery-pdp"
              tabIndex={150}
              role="dialog"
              aria-labelledby="myLargeModalLabel3"
            >
              <Slider
                key="slider-zoom-gallery"
                {...getSlickSettings(width)}
                ref={ref => (slickRef.current = ref)}
                tabIndex={151}
              >
                {data && pdpCustomImagesArray && pdpImageArrayLength ? (
                  pdpCustomImagesArray.map((element, i) => {
                    const resourcePdpImageName =
                      element?.resourceName?.[0] || ""
                    const layerImageResourse = element?.layerUrl
                    const resourcePdpImageUrl =
                      element?.resourceFullWebUrl?.[0] || ""

                    const resourcePdpImageAlt =
                      element?.resourceAltText?.[0] || ""

                    return (
                      <React.Fragment key={`imageg${i}`}>
                        {!element.type ? (
                          <div
                            key={`zoom-image-${element?.assetId}`}
                            className={`image-wrapper ${
                              element?.assetId === activeImage ||
                              resourcePdpImageName === activeImage ||
                              layerImageResourse === activeImage
                                ? "imageActive "
                                : ""
                            } 
                              ${
                                resourcePdpImageUrl && resourcePdpImageName
                                  ? "overlay-image-360 "
                                  : ""
                              }
                              ${
                                (element?.assetId === activeImage &&
                                  threeSixtyZoomClick) ||
                                (resourcePdpImageName === activeImage &&
                                  !threeSixtyZoomClick)
                                  ? "remove-border "
                                  : ""
                              }
                              `}
                          >
                            {resourcePdpImageUrl && resourcePdpImageName ? (
                              <div
                                className="zoom-three-sixty"
                                onClick={() =>
                                  threeSixtyOpen(
                                    resourcePdpImageName,
                                    resourcePdpImageAlt,
                                    i
                                  )
                                }
                              >
                                <Image
                                  role="img"
                                  src={resourcePdpImageUrl}
                                  alt={resourcePdpImageAlt}
                                  width={60}
                                  height={60}
                                />
                                <span className="zoom-video-icon">
                                  <img
                                    src={threeSixtyIcon?.src}
                                    alt={resourcePdpImageAlt}
                                    tabIndex={`10 ${+i}`}
                                  />
                                </span>
                              </div>
                            ) : (
                              <Image
                                role="img"
                                src={
                                  layerImageResourse
                                    ? layerImageResourse
                                    : appendPresetToUrl(
                                        assetAccountName,
                                        swatchUrl,
                                        element.assetId,
                                        width,
                                        presetConfigObject,
                                        true
                                      )
                                }
                                alt={element.label}
                                width={60}
                                height={60}
                                tabIndex={`10${+i}`}
                                onClick={() =>
                                  imageZoomClick(
                                    layerImageResourse || element.assetId,
                                    i,
                                    element?.label
                                  )
                                }
                              />
                            )}
                          </div>
                        ) : (
                          <div
                            key={`zoom-video-${i}`}
                            onClick={() => imageZoomVideoClick(element.url, i)}
                            className={`image-wrapper zoom-video-section ${
                              element.url === activeImage ? "imageActive" : ""
                            }`}
                          >
                            <VideoWrapper
                              thumb
                              videoId={element.url}
                              getVideoInfo={getVideoInfo}
                              index={i}
                              totalPdpImages={pdpImageArrayLength}
                              zoomEntryPoint={zoomEntryPoint}
                            />
                            <span className="zoom-video-icon">
                              <img
                                src={zoomVideoIcon?.src}
                                alt="zoom video"
                                tabIndex={110 + i}
                              />
                            </span>
                          </div>
                        )}
                      </React.Fragment>
                    )
                  })
                ) : (
                  <div className="image-wrapper  imageActive">
                    {initialImgUrl && pdpDesktopImage ? (
                      <img
                        role="button"
                        src={pdpDesktopImage.replace(
                          "/}",
                          `/${initialImgUrl}}`
                        )}
                        alt={initialImgAlt}
                        tabIndex="105"
                        className="print"
                        onClick={() =>
                          imageZoomClick(initialImgUrl, 0, initialImgAlt)
                        }
                      />
                    ) : (
                      <p className="shimmer-loading__para shimmer height-400" />
                    )}
                  </div>
                )}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ImageHeroSection
